import { Link } from "easy-page-router/react";
import { useLang } from "../services/lang";

export default function LaunchButton() {
    const { dict } = useLang();

    return <Link href={`/${dict.url}`} className="launch-button">
        <div className="launch-block" />
        <div className="launch-block" />
        <div className="launch-block" />
        <div className="launch-block" />
    </Link>
}